import { render, staticRenderFns } from "./BillingPlans.vue?vue&type=template&id=3be1e886"
import script from "./BillingPlans.vue?vue&type=script&lang=js"
export * from "./BillingPlans.vue?vue&type=script&lang=js"
import style0 from "./BillingPlans.vue?vue&type=style&index=0&id=3be1e886&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports